import { createStore, applyMiddleware } from "redux";

// Reducers
import reducers from "./reducers";
// Logger with default options
import logger from "redux-logger";

export default function configureStore(initialState) {
  return createStore(reducers, initialState, applyMiddleware(logger));
}
